import { Avatar, Divider, Grid, Paper, Typography } from "@mui/material";
import React, { useMemo, useRef } from "react";
import { FaEdit, FaTimes } from "react-icons/fa";
import { MdLogout } from "react-icons/md";
import CustomButton from "../../components/CustomButton/Index";
import CustomInputField from "../../components/CustomInputField/Index";
import CustomTimeTable from "../../components/CustomTimeTable/Index";
import DashboardLayout from "../../layouts";
import offerStyles from "../../styles/pages/VisaCategory/index.style";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ConfirmationDialog from "../../components/ConfirmationDialog/Index"; // Adjust the import path as necessary
import url from "../../API";
import DashboardHeader from "../../components/DashHeader/Index";
import JoditEditor from "jodit-react";
export default function EntryPage() {
  const classes = offerStyles();
  const navigate = useNavigate();
  const token = localStorage.getItem("tkn");
  const [state, setState] = React.useState({
    entry_type_name: "",
    entrytype_descriptions: "",
    searchText: "",
    isUpdate: false,
  });
  const [entryList, setEntryList] = React.useState([]);
  const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(false);
  const [deleteEntryId, setDeleteEntryId] = React.useState(null);
  const editor = useRef(null);
  const config = useMemo(
    () => ({
      readonly: false, // all options from https://xdsoft.net/jodit/docs/,
      placeholder: "",
    }),
    []
  );
  function table() {
    axios
      .get(url + "entrytype/getallentrytype", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        // Handle the response
        setEntryList(response.data.EntryType);
        //console.log(response.data.EntryType);
      })
      .catch((error) => {
        // Handle errors
        //console.error("Error fetching data:", error);
      });
  }

  React.useEffect(() => {
    table();
  }, []);

  const handleSaveEntry = () => {
    axios
      .post(
        url + "entrytype/createentrytype",
        {
          entry_type_name: state.entry_type_name,
          entrytype_descriptions: state.entrytype_descriptions,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((r) => {
        if (r.data.status == 200) {
          toast.success("Created Sucessfully", {
            position: "top-center",
          });

          window.scrollTo({ top: 500, behavior: "smooth" });
          table();
        }
      })
      .catch((error) => {
        //console.error("Error fetching data:", error);
        // Handle error here
      });
    setState({
      entry_type_name: "",
      entrytype_descriptions: "",
    });
  };

  const handleDeleteEntry = (idx) => {
    setDeleteEntryId(idx);
    setConfirmDialogOpen(true);
  };

  const handleConfirmDelete = () => {
    axios
      .post(
        url + "entrytype/deleteentrytype",
        {
          id: deleteEntryId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((r) => {
        if (r.data.status == 200) {
          toast.success("Deleted Sucessfully", {
            position: "top-center",
          });
          table();
        }
      })
      .catch((error) => {
        //console.error("Error fetching data:", error);
        // Handle error here
      });
    setConfirmDialogOpen(false);
  };

  const handleUpdateEntry = (idx) => {
    axios
      .post(
        url + "entrytype/updateentrytype",
        {
          id: idx,
          entry_type_name: state.entry_type_name,
          entrytype_descriptions: state.entrytype_descriptions,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((r) => {
        if (r.data.status == 200) {
          toast.success("Updated Sucessfully", {
            position: "top-center",
          });

          window.scrollTo({ top: 500, behavior: "smooth" });
          table();
        }
      })
      .catch((error) => {
        //console.error("Error fetching data:", error);
        // Handle error here
      });
    setState({
      entry_type_name: "",
      entrytype_descriptions: "",
      isUpdate: false,
    });
  };

  const handleConfirmDialogClose = () => {
    setConfirmDialogOpen(false);
  };

  return (
    <div className={classes.container}>
      <DashboardLayout />
      <div className={classes.contentSection}>
        <DashboardHeader />
        <Divider className={classes.divider} />
        <div
          className={classes.contentHead}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {" "}
            <p style={{ marginTop: "2px", fontSize: "22px" }}>
              Visa Entry Type
            </p>
          </div>
        </div>
        <Divider className={classes.divider} />
        <div className={classes.contentMain}>
          <p className={classes.title}>Entry type</p>
          <Paper className={classes.paper}>
            <Grid container spacing={3} className="content" alignItems={"end"}>
              <Grid item xs={5}>
                <CustomInputField
                  label="Visa Entry Type"
                  fullWidth
                  value={state.entry_type_name}
                  onChange={(e) => {
                    const input = e.target.value;
                    // Remove non-alphabetic characters
                    const validInput = input.replace(/[^a-zA-Z\s]/g, "");
                    // Ensure input does not exceed 50 characters
                    const trimmedInput = validInput.slice(0, 50);
                    setState({
                      ...state,
                      entry_type_name: trimmedInput,
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <p>Entry Type Description</p>
                <JoditEditor
                  ref={editor}
                  value={state.entrytype_descriptions}
                  tabIndex={1} // tabIndex of textarea
                  onBlur={(newContent) =>
                    setState({
                      ...state,
                      entrytype_descriptions: newContent,
                    })
                  } // preferred to use only this option to update the content for performance reasons
                  onChange={(newContent) => {}}
                  config={config}
                />
              </Grid>
              <Grid item xs={2} alignItems="end">
                {state.isUpdate ? (
                  <CustomButton
                    text={"Update"}
                    variant="contained"
                    color="warning"
                    fullWidth
                    onClick={(e) => {
                      if (!!state.entry_type_name) {
                        handleUpdateEntry(state.visaId);
                      } else {
                        toast.error("Fill all the information", {
                          position: "top-center",
                        });
                      }
                    }}
                  />
                ) : (
                  <CustomButton
                    text={"create"}
                    variant="contained"
                    fullWidth
                    onClick={(e) => {
                      if (!!state.entry_type_name) {
                        handleSaveEntry();
                      } else {
                        toast.error("Fill all the information", {
                          position: "top-center",
                        });
                      }
                    }}
                  />
                )}
              </Grid>
            </Grid>
            <ToastContainer />
          </Paper>
          <p className={classes.title}>Entry Lists</p>
          <Paper className={classes.paper}>
            <CustomInputField
              label="Search..."
              fullWidth
              value={state.searchText}
              onChange={(e) =>
                setState({
                  ...state,
                  searchText: e.target.value,
                })
              }
              className="searchField"
            />
            <CustomTimeTable
              fullWidth
              cols={["Sl No.", "Entry Type", "Description", "Action"]}
              rows={[
                ...entryList
                  .filter((l) => {
                    const type_name = l.entry_type_name?.toLowerCase() || "";
                    const description =
                      
                        l.entrytype_descriptions
                      ?.toLowerCase() || "";
                    const searchLower = (state.searchText || "").toLowerCase();
                    return (
                      type_name.includes(searchLower) ||
                      description.includes(searchLower) ||
                      searchLower === undefined
                    );
                  })
                  .map((vs, idx) => [
                    idx + 1,
                    vs.entry_type_name,
                    <div dangerouslySetInnerHTML={{ __html: vs.entrytype_descriptions }} />,
                    <span className={classes.actionBtn}>
                      <CustomButton
                        variant="contained"
                        color="error"
                        onClick={() => handleDeleteEntry(vs.id)}
                        icon={<FaTimes />}
                      />
                      <CustomButton
                        variant="contained"
                        color="warning"
                        onClick={() => {
                          setState({
                            entry_type_name: vs.entry_type_name,
                            entrytype_descriptions:
                              vs.entrytype_descriptions,
                            isUpdate: true,
                            visaId: vs.id,
                          });
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                        icon={<FaEdit />}
                      />
                    </span>,
                  ]),
              ]}
            />
          </Paper>
        </div>
      </div>
      <ConfirmationDialog
        open={confirmDialogOpen}
        onClose={handleConfirmDialogClose}
        onConfirm={handleConfirmDelete}
      />
    </div>
  );
}
